
// eslint-disable-next-line no-unused-vars
import SelectedDance from "@/model/selected_dance";
// eslint-disable-next-line no-unused-vars
import GradeFilter from "@/model/grade_filter";
import DanceFilter from "@/model/dance_filter";
import { defineComponent, inject, onBeforeMount, reactive, ref } from "vue";
// eslint-disable-next-line no-unused-vars
import IConfigurationService from "../interfaces/configuration_service";
// eslint-disable-next-line no-unused-vars
import ITuneSelectorService from "../interfaces/tune_selector_service";

// eslint-disable-next-line no-unused-vars
import ITrackFilters, { ITrack } from "@/interfaces/track_filters";
import { useGtag } from "vue-gtag-next";

interface ITuneEnded
{
	ended:boolean
}

export default defineComponent({
  name: 'TuneSelector',
  setup()
  {
	const configurationService = inject<IConfigurationService>("configurationService");
	// const tuneSelectorService = inject<ITuneSelectorService>("tuneSelectorService");

	let filterToApply = ref<string | null>(null);
	let danceFilterToApply = ref<string | null>(null);
	let setDanceFilterToApply = ref<string | null>(null);
	let miscellaneousFilterToApply = ref<string | null>(null);
	const setDanceCategoryFilterToApply = ref<string>();
	let gradeFilters = reactive<Array<GradeFilter>>([]);
	let danceFilters = reactive<Array<DanceFilter>>([]);
	let setDanceTypeFilters = reactive<Array<DanceFilter>>([]);
	let miscellaneousFilters = reactive<Array<DanceFilter>>([]);
	// const showPlaylists = ref<boolean>(false);

	// Controls filtering of all clinical applications
	// const playAllAudio = reactive<Array<SelectedDance>>([]);
	const audioToPlayFirstGroup = reactive<Array<SelectedDance>>([]);
	const audioToPlaySecondGroup = reactive<Array<SelectedDance>>([]);
	const audioToPlayThirdGroup = reactive<Array<SelectedDance>>([]);
	
	if (!configurationService)
	{
		throw new Error("Configuration service not initialised");
	}
	const selectedRegion = configurationService?.getSelectedRegion();
	const selectedRegionName = configurationService?.getSelectedRegionName();
	const allActionFilters = configurationService?.getAllActionFilters();
	const allGradeFilters = configurationService?.getAllGradeFilters();
	const showBiography = ref(false);
	const currentlySelectedTrack = reactive<SelectedDance>({grade: "", audioFilename:"", category:"", group:"", bars:"",speed:"",trackListing:"", audioElement: new Audio(""), isSelected: false, isPlaying: false});
	const audioPlayerRef = ref<HTMLAudioElement>();
	const comingSoon = ref(false);
	// const nextTuneIndex = ref(0);
	const _grade = ref("Beginner");
	const _dance = ref("Reels");
	
	// let activeTrack = 0;
	// let musicTracker = 'noMusic';
		//playlist audios
	// let audios: Array<HTMLAudioElement> = [];

	const { pageview } = useGtag() 
	const trackScreenview = () => {
		pageview({ page_path: "/music" });
	};

	
	function bioSelected() {
		
		showBiography.value = !showBiography.value;
	}
	function playAudio() { 	
		for(var track of audioToPlayFirstGroup) {
			track.isPlaying =  (track.audioFilename === currentlySelectedTrack.audioFilename);
			track.audioElement.currentTime = 0;
			track.audioElement.loop = false;
			track.isSelected = false;
			track.audioElement.pause();
		}
		for(var track1 of audioToPlaySecondGroup) {
			track1.isPlaying =  (track1.audioFilename === currentlySelectedTrack.audioFilename);
			track1.audioElement.currentTime = 0;
			track1.audioElement.loop = false;
			track1.isSelected = false;
			track1.audioElement.pause();
		}
		for(var track2 of audioToPlayThirdGroup) {
			track2.isPlaying = (track2.audioFilename === currentlySelectedTrack.audioFilename);
			track2.audioElement.currentTime = 0;
			track2.audioElement.loop = false;
			track2.isSelected = false;
			track2.audioElement.pause();
		}

		if (currentlySelectedTrack.audioElement)
		{
			currentlySelectedTrack.isPlaying = true;
			currentlySelectedTrack.audioElement.currentTime = 0;
			currentlySelectedTrack.audioElement.loop = (filterToApply.value === 'Sets' && setDanceCategoryFilterToApply.value !== 'Trad Set Dances' && audioToPlayThirdGroup.length !== 0);		
			currentlySelectedTrack.audioElement.play();
		}
	} 

	function pauseAudio() { 
		for(var track of audioToPlayFirstGroup) {
			track.isPlaying =  false; //(track.audioFilename === currentlySelectedTrack.audioFilename);
		}
		for(var track1 of audioToPlaySecondGroup) {
			track1.isPlaying =  false; //(track1.audioFilename === currentlySelectedTrack.audioFilename);
		}
		for(var track2 of audioToPlayThirdGroup) {
			track2.isPlaying =  false; //(track2.audioFilename === currentlySelectedTrack.audioFilename);
		}
		if (currentlySelectedTrack.audioElement)
		{
			//currentlySelectedTrack.isPlaying = false;
			currentlySelectedTrack.audioElement.currentTime = 0;
			currentlySelectedTrack.audioElement.pause();
		}
	} 

	function disableAudio()
	{
		resetAudioPlayer();
		if (currentlySelectedTrack.audioElement)
		{
			currentlySelectedTrack.audioElement.currentTime = 0;
			currentlySelectedTrack.audioElement.src = "";
		}
	}

	function resetAudioPlayer()
	{
		currentlySelectedTrack.audioFilename = "";
		currentlySelectedTrack.isPlaying = false;
		currentlySelectedTrack.isSelected = false;
	}
	// fired when a filter is clicked and handles the data coming from serviceline_filter_box component
	function changeFilter(value: string): void 
	{	
		comingSoon.value = value === "Ceili's";
		pauseAudio();

		setGradeFilters(value)
		filterToApply.value = value;
		
		if (value === "Sets")
		{
			changeSetDanceFilter("Hornpipe Set Dances")
		}
		else if (value === "Misc")
		{
			changeMiscellaneousFilter("Traditional Hornpipe");
		}
		else
		{
			changeDanceFilter("Reels");
		}
	}
	function changeDanceFilter(value: string): void 
	{
		pauseAudio();

		setDanceFilters(value)
		danceFilterToApply.value = value;

		if (filterToApply.value)
		{
			danceTypeClicked(filterToApply.value, value);
		}
	}
	function changeSetDanceFilter(value: string): void 
	{
		pauseAudio();
		
		setSetDanceTypeFilters(value)
		setDanceFilterToApply.value = value;
		if (filterToApply.value)
		{
			setDanceTypeClicked(filterToApply.value, value);
		}
	}
	function changeMiscellaneousFilter(value: string): void 
	{
		pauseAudio();

		setMiscellaneousFilters(value)
		miscellaneousFilterToApply.value = value;

		if (filterToApply.value)
		{
			miscellaneousTypeClicked(filterToApply.value, value);
		}
	}

	function danceTypeClicked(grade: string, dance: string)
	{
		disableAudio();

		// Control the play all option
		_grade.value = grade;
		_dance.value = dance;

		// Pulled selectedAudio out to this level so that it's only randomised once..
		let selectedAudio = configurationService?.getTracksForGradeAndCategory(grade, dance); 
		if (selectedAudio && selectedAudio.default.length > 0)
		{
			copyTracksToFirstGroup(selectTracksForGroup(selectedAudio, "1"));
			console.log(`First Group Is : ${JSON.stringify(selectTracksForGroup(selectedAudio, "1"))}`)
			console.log(`First Group Is : ${JSON.stringify(audioToPlayFirstGroup)}`)
			if (selectedAudio.default.length > 9)
			{
				copyTracksToSecondGroup(selectTracksForGroup(selectedAudio, "2"));
			}
			if (selectedAudio.default.length > 19)
			{
				copyTracksToThirdGroup(selectTracksForGroup(selectedAudio, "3"));
			}
		}
	}
	function setDanceTypeClicked(category: string, dance: string)
	{
		pauseAudio();
		disableAudio();

		filterToApply.value = category;
		
		if (dance === 'Trad Set Dances')
		{
			// Now selectTradSets and display
			copyTracksToFirstGroup(selectTradSets());
		}
		else if (dance === 'Hornpipe Set Dances')
		{
			setDanceNameClicked('Hornpipe Set Dances', 'Ace and Deuce');
		}
		else if (dance === "Jig Set Dances")
		{
			setDanceNameClicked('Jig Set Dances', 'Blackthorn Stick');
		}
		setDanceCategoryFilterToApply.value = dance;
		setDanceFilterToApply.value = dance;
	}
	function setDanceNameClicked(category: string, dance: string)
	{
		pauseAudio();
		disableAudio();

		if (dance !== undefined)
		{
			copyTracksToFirstGroup(selectSetDanceTracksForGroup(category, dance, "1"));
			copyTracksToSecondGroup(selectSetDanceTracksForGroup(category, dance, "2"));
			
			copyTracksToThirdGroup(selectSetDanceTracksForGroup(category, dance, "3"));
		}
		
		setDanceCategoryFilterToApply.value = category;
		setDanceFilterToApply.value = dance;
	}

	// function playContinuous()
	// {
	// 	pauseAudio();
	// 	disableAudio();

	// 	showPlaylists.value = true;
	// 	nextTuneIndex.value = 0;
	// 	if (musicTracker == 'playMusic')
	// 	{
	// 		stop();
	// 	}
		
	// 	let selectedAudio = configurationService?.getTracksForGradeAndCategory(_grade.value, _dance.value); 
	// 	if (audios[activeTrack] !== undefined)
	// 	{
	// 		audios[activeTrack].removeEventListener('ended',function() {
	// 				stop();
	// 			});
	// 	}

	// 	audios.splice(0);

	// 	playAllAudio.splice(0);
	// 	playAllAudio.push(...selectTracksForGroup(selectedAudio!, "1"));
	// 	playAllAudio.push(...selectTracksForGroup(selectedAudio!, "2"));
	// 	playAllAudio.push(...selectTracksForGroup(selectedAudio!, "3"));
	// 	console.log(`Tracks selected: ${JSON.stringify(playAllAudio)}`)

	// 	playlist();
	// }
	// function playlist()
	// {
	// 	// let selectedAudio = configurationService?.getTracksForGradeAndCategory("Beginner", "Reels"); 
	// 	// 	console.log(`Tracks selected: ${JSON.stringify(selectedAudio)}`)
	// 	// copyTracksToFirstGroup(selectTracksForGroup(selectedAudio!, "1"));
		

	// 	if (playAllAudio[nextTuneIndex.value].audioElement)
	// 	{
	// 		for(const track of playAllAudio)
	// 		{
	// 			let load = track.audioElement;
	// 			load.load();
	// 			load.addEventListener('ended',function() {
	// 				forward();
	// 			});
	// 			audios.push(load);
	// 		}

	// 		if (musicTracker == 'noMusic') {
	// 			audios[activeTrack].play();
	// 			musicTracker = 'playMusic';
	// 		} else {
	// 			audios[activeTrack].pause();
	// 			musicTracker = 'noMusic';
	// 		}
	// 	}
	// }
	// var stop = function() {
	// 	if (musicTracker == 'playMusic') {
	// 		audios[activeTrack].pause();
	// 		audios[activeTrack].currentTime = 0;
	// 		audios[activeTrack].play();
	// 	} else {
	// 		audios[activeTrack].currentTime = 0;
	// 	}
	// };
	// var forward = function(){
	// 	function increment(){
	// 		if (activeTrack < audios.length - 1)
	// 			activeTrack++;
	// 		else
	// 			activeTrack = 0;
	// 	}

	// 	if (musicTracker === 'playMusic') {
	// 		audios[activeTrack].pause();
	// 		increment();
	// 		audios[activeTrack].currentTime = 0;
	// 		audios[activeTrack].play();
	// 	} else {
	// 		increment();
	// 	}

	// };
	function miscellaneousTypeClicked(category: string, dance: string)
	{
		disableAudio();
		filterToApply.value = category;
		if (dance === 'Traditional Hornpipe')
		{
			copyTracksToFirstGroup(selectTradHornpipeTracks());
		}
		if (dance === 'Showcases')
		{
			copyTracksToFirstGroup(selectShowcaseTracks());
		}
		if (dance === 'Traditional Heavy Jig')
		{
			copyTracksToFirstGroup(selectTradJigTracks());
		}
		// if (dance === 'Playlists')
		// {
		// 	showPlaylists.value = true;
		// 	playlist();
		// }
		setDanceCategoryFilterToApply.value = dance;
		miscellaneousFilterToApply.value = dance;
	}

	function selectTradSets(): Array<SelectedDance>
	{
		let selectedAudio = configurationService?.getTraditionalSetTracks();
		return selectTracksToPlay(selectedAudio);
	}

	function selectTradHornpipeTracks(): Array<SelectedDance>
	{
		let selectedAudio = configurationService?.getTraditionalHornpipeTracks();
		return selectTracksToPlay(selectedAudio);
	}

	function selectShowcaseTracks(): Array<SelectedDance>
	{
		let selectedAudio = configurationService?.getShowcaseTracks();
		return selectTracksToPlay(selectedAudio);
	}

	function selectTradJigTracks(): Array<SelectedDance>
	{
		let selectedAudio = configurationService?.getTraditionalJigTracks();
		return selectTracksToPlay(selectedAudio);
	}
	function selectSetDanceTracksForGroup(category: string, dance: string, group: string): Array<SelectedDance>
	{
		let selectedAudio = configurationService?.getSetDanceTracks(dance); 
		
		if (selectedAudio !== undefined)
		{
			let selected: ITrack[] = [];
			// For set dances, group 3 are the looping tracks.
			if (category === "Hornpipe Set Dances" && group === "3")
			{
				selected = selectedAudio.default.map((track) => track).filter((item) =>  item.grade === category && item.category === dance && item.trackListing.substring(0,5) === "[ 76]"&& item.group === group);
			}
			else if (category === "Jig Set Dances" && group === "3")
			{
				selected = selectedAudio.default.map((track) => track).filter((item) =>  item.grade === category && item.category === dance  && item.trackListing.substring(0,4) === "[66]" && item.group === group);
			}
			else 
			{
				selected = selectedAudio.default.map((track) => track).filter((item) =>  item.grade === category && item.category === dance && item.group === group);
			}
			
			const selectedTracks = new Array<SelectedDance>();
			for(const track of selected)
			{
				selectedTracks.push(new SelectedDance({
					grade: track.grade,
					category: track.category,
					bars: track.bars,
					speed: track.speed,
					group: track.group,
					trackListing: track.trackListing,
					audioFilename: track.audioElement,
					audioElement: new Audio(track.audioElement),
					isPlaying: track.isPlaying,
					isSelected: track.isSelected
				}))
			}
			
			return selectedTracks;
		}
		return [];
	}
	function selectSetDanceLoopTracks(category: string, dance: string, speed: string, group: string): Array<SelectedDance>
	{
		let selectedAudio = configurationService?.getSetDanceTracks(dance); 
		
		if (selectedAudio !== undefined)
		{
			const selected = selectedAudio.default.map((track) => track).filter((item) =>  item.grade === category && item.category === dance && item.group === group && item.trackListing.includes(speed))
			
			const selectedTracks = new Array<SelectedDance>();
			for(const track of selected)
			{
				selectedTracks.push(new SelectedDance({
					grade: track.grade,
					category: track.category,
					bars: track.bars,
					speed: track.speed,
					group: track.group,
					trackListing: track.trackListing,
					audioFilename: track.audioElement,
					audioElement: new Audio(track.audioElement),
					isPlaying: track.isPlaying,
					isSelected: track.isSelected
				}))
			}
			
			return selectedTracks;
		}
		return [];
	}
	function selectTracksForGroup(selectedAudio: ITrackFilters, group: string): Array<SelectedDance>
	{
		if (selectedAudio !== undefined)
		{
			const selected = selectedAudio.default.filter((item, index) => {
				if (group === "1")
				{
					if (index < 10)
					{
						return item;
					}
				}
				if (group === "2")
				{
					if (index > 9 && index < 20)
					{
						return item;
					}
				}
				if (group === "3")
				{
					if (index > 19 && index < 30)
					{
						return item;
					}
				}

			});
			
			const selectedTracks = new Array<SelectedDance>();
			for(const track of selected)
			{
				selectedTracks.push(new SelectedDance({
					grade: track.grade,
					category: track.category,
					bars: track.bars,
					speed: track.speed,
					group: track.group,
					trackListing: track.trackListing,
					audioFilename: track.audioElement,
					audioElement: new Audio(track.audioElement),
					isPlaying: track.isPlaying,
					isSelected: track.isSelected
				}))
			}

			return selectedTracks;
		}
		return [];
	}


	function selectTracksToPlay(selectedAudio: ITrackFilters | undefined): Array<SelectedDance>
	{
		if (selectedAudio !== undefined)
		{
			const selectedTracks = new Array<SelectedDance>();
			for(const track of selectedAudio?.default)
			{
				selectedTracks.push(new SelectedDance({
					grade: track.grade,
					category: track.category,
					bars: track.bars,
					speed: track.speed,
					group: track.group,
					trackListing: track.trackListing,
					audioFilename: track.audioElement,
					audioElement: new Audio(track.audioElement),
					isPlaying: track.isPlaying,
					isSelected: track.isSelected
				}))
			}

			return selectedTracks;
		}
		return [];
	}

	function copyTracksToFirstGroup(tracks: Array<SelectedDance>)
	{
		audioToPlaySecondGroup.length = 0;
		audioToPlayThirdGroup.length = 0;
		audioToPlayFirstGroup.length = 0;
		audioToPlayFirstGroup.push(...tracks);
	}
	function copyTracksToSecondGroup(tracks: Array<SelectedDance>)
	{
		audioToPlaySecondGroup.length = 0;
		audioToPlayThirdGroup.length = 0;
		audioToPlaySecondGroup.push(...tracks);
	}
	function copyTracksToThirdGroup(tracks: Array<SelectedDance>)
	{
		audioToPlayThirdGroup.length = 0;
		audioToPlayThirdGroup.push(...tracks);
	}

	function load(selectedTrack: SelectedDance) {

		if (selectedTrack) {
			setCurrentlySelectedTrack(selectedTrack);

			// if (audioPlayerRef.value)
			// {
			// 	console.log(`Setting track name to play...${selectedTrack.audioFilename}`)
		
			// 	audioPlayerRef.value.src = selectedTrack.audioFilename;
			// }
			
			playAudio();
		}
    }

	function setCurrentlySelectedTrack(track: SelectedDance)
	{
		currentlySelectedTrack.grade = track.grade;
		currentlySelectedTrack.category = track.category;
		currentlySelectedTrack.bars = track.bars;
		currentlySelectedTrack.speed = track.speed;
		currentlySelectedTrack.group = track.group;
		currentlySelectedTrack.trackListing = track.trackListing;
		currentlySelectedTrack.audioFilename = track.audioFilename;
		currentlySelectedTrack.audioElement = track.audioElement;
		// currentlySelectedTrack.audioElement = new Audio(track.audioFilename);
		currentlySelectedTrack.isPlaying = track.isPlaying;
	}

	// This is so that we can un-highlight the selected button
	function unhighlightDanceBtn()
	{
		for (const audio of audioToPlayFirstGroup) {
			audio.isSelected = false;
		}
		for (const audio of audioToPlaySecondGroup) {
			audio.isSelected = false;
		}
		for (const audio of audioToPlayThirdGroup) {
			audio.isSelected = false;
		}
	}
	
	function trackSelected(track: SelectedDance):void
	{
		pauseAudio();
		
		if (track) {
			load(track);
			unhighlightDanceBtn();
			
			// Don't refresh the tracks if the current track is already a "looped" track!!
			if (filterToApply.value === 'Sets' && track.group !== "3")
			{
				copyTracksToThirdGroup(selectSetDanceLoopTracks(track.grade, track.category, track.trackListing.substr(0,5), "3"));	
			}

			track.isSelected = true;
		}
	}

	function loadGradeFilters()
	{
		gradeFilters.length = 0;
		const filters = allGradeFilters.default.map((filter) => filter)
		for(const filter of filters)
		{
			gradeFilters.push(new GradeFilter({
				grade: filter.grade,
				description: filter.description,
				imageUrl: filter.imageUrl,
				colour: filter.colour, 
				inactive: filter.inactive
			}));
		}
	}

	function loadDanceFilters()
	{
		danceFilters.length = 0;
		const filters = allActionFilters.default.map((filter) => filter)
			.filter((item) => item.type === "dance-filter");
		for(const filter of filters)
		{
			danceFilters.push(new DanceFilter({
				dance: filter.dance,
				group: "1",
				isSelected: filter.isSelected
			}));
		}
	}

	function loadSetDanceTypeFilters()
	{
		setDanceTypeFilters.length = 0;
		const filters = allActionFilters.default.map((filter) => filter)
			.filter((item) => item.type === "set-dance-type-filter");
		for(const filter of filters)
		{
			setDanceTypeFilters.push(new DanceFilter({
				dance: filter.dance,
				group: "1",
				isSelected: filter.isSelected
			}));
		}
	}

	function loadMiscellaneousFilters()
	{
		miscellaneousFilters.length = 0;
		const filters = allActionFilters.default.map((filter) => filter)
			.filter((item) => item.type === "miscellaneous-filter");
		for(const filter of filters)
		{
			miscellaneousFilters.push(new DanceFilter({
				dance: filter.dance,
				group: "1",
				isSelected: filter.isSelected
			}));
		}
	}

	function setGradeFilters(value: string)
	{
		filterToApply.value = value;

		if (gradeFilters)
		{
			for(const filter of gradeFilters)
			{
				filter.inactive = (filter.grade === value ? "" : "inactive");
			}
		}
	}

	function setDanceFilters(value: string)
	{
		if (danceFilters)
		{
			for(const filter of danceFilters)
			{
				filter.isSelected = (filter.dance === value ? "site-btn-primary" : "site-btn-outline-primary")
			}
		}
	}

	function setSetDanceTypeFilters(value: string)
	{
		if (setDanceTypeFilters)
		{
			for(const filter of setDanceTypeFilters)
			{
				filter.isSelected = (filter.dance === value ? "site-btn-primary" : "site-btn-outline-primary")
			}
		}
	}
	function setMiscellaneousFilters(value: string)
	{
		if (miscellaneousFilters)
		{
			for(const filter of miscellaneousFilters)
			{
				filter.isSelected = (filter.dance === value ? "site-btn-primary" : "site-btn-outline-primary")
			}
		}
	}

	onBeforeMount(function()
	{
		console.log(`selectedRegion: ${JSON.stringify(selectedRegion)}`)
		loadGradeFilters();
		loadDanceFilters();
		loadSetDanceTypeFilters();
		loadMiscellaneousFilters();
		setGradeFilters("Beginner");
		setDanceFilters("Reels");
		setSetDanceTypeFilters("Hornpipe Set Dances");
		setMiscellaneousFilters("Traditional Hornpipe");
		danceTypeClicked("Beginner","Reels");
	});

    return {
		trackSelected,
		audioToPlayFirstGroup,
		audioToPlaySecondGroup,
		audioToPlayThirdGroup,
		danceFilters,
		gradeFilters,
		setDanceTypeFilters,
		miscellaneousFilters,
		filterToApply,
		danceFilterToApply,
		setDanceFilterToApply,
		setDanceCategoryFilterToApply,
		miscellaneousFilterToApply,
		changeFilter,
		changeDanceFilter,
		changeSetDanceFilter,
		changeMiscellaneousFilter,
		setDanceTypeClicked,
		setDanceNameClicked,
		pauseAudio,
		audioPlayerRef,
		currentlySelectedTrack,
		selectedRegion,
		selectedRegionName,
		bioSelected,
		showBiography,
		comingSoon,
		trackScreenview
    };
  }
});
